import { useEffect } from 'react';
import { useChatStore } from '../store/chat-store';

/**
 * "Replying to X" strip shown directly above the composer when the user
 * has picked a message to reply to (WhatsApp style). Esc or the ✕ clears it.
 * The actual replyToId is read off the store by socket-client.send().
 */
export function ReplyBanner() {
  const target = useChatStore(s => s.replyTarget);
  const clear = useChatStore(s => s.setReplyTarget);

  useEffect(() => {
    if (!target) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') clear(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [target, clear]);

  if (!target) return null;

  const preview = target.text.length > 120 ? `${target.text.slice(0, 120)}…` : target.text;

  return (
    <div className="flex items-start gap-2 border-t border-gray-100 bg-gray-50 px-3 py-2">
      <div className="w-1 self-stretch rounded-full" style={{ background: 'var(--vip-primary)' }} />
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-semibold" style={{ color: 'var(--vip-primary)' }}>
          Replying to {target.userName}
        </div>
        <div className="text-xs text-gray-500 truncate">{preview}</div>
      </div>
      <button
        type="button"
        aria-label="Cancel reply"
        onClick={() => clear(null)}
        className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-200 transition"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
